import { EVENT_KEYS } from 'presentation/events';
import { getLists, createList, deleteList, updateList, ListUpdate } from 'core/services/lists.service';
import { deleteEntries } from 'core/services/tasks.service';
import { createRequesterMediator } from 'mediators/utils'

const createNewList = (newList) => {
    return async (dispatch, getState) => {
        let { user } = getState().login;
        let list = await createList(user.id, newList);

        dispatch({
            type : EVENT_KEYS.UPDATE_ALL_ENTRIES,
            payload : []
        });

        dispatch({
            type : EVENT_KEYS.UPDATE_SELECTED_TASK_LIST,
            payload : list
        });
    };
};

const deleteAList = (listId) => {
    return async (dispatch, getState) => {
        let { user } = getState().login;
        await deleteList(user.id, listId);
        await deleteEntries(user.id, listId);

        dispatch({
            type : EVENT_KEYS.UPDATE_SELECTED_TASK_LIST,
            payload : null
        });

        dispatch({
            type : EVENT_KEYS.UPDATE_ALL_ENTRIES,
            payload : []
        });

        let listData = await getLists(user.id);
        dispatch({
            type : EVENT_KEYS.SET_TASK_LISTS,
            payload : listData
        });
    };
};

const selectList = (list) => {
    return (dispatch, getState) => {
        let { selectedList } = getState();
        dispatch({
            type : EVENT_KEYS.UPDATE_SELECTED_TASK_LIST,
            payload : list
        });

        if(!list || (selectedList && selectedList.id !== list.id)) {
            dispatch({
                type : EVENT_KEYS.RESET_TASKS
            });

            dispatch({
                type : EVENT_KEYS.UPDATE_ALL_ENTRIES,
                payload : []
            });
        }
    };
};

const getTaskLists = (userId) => {
    return async (dispatch) => {
        let listData = await getLists(userId);
        dispatch({
            type : EVENT_KEYS.SET_TASK_LISTS,
            payload : listData
        });
    };
};

export const mediateCreateTaskListRequester = (createListSignal, dispatch) => {
    const handleSignal = (payload) => {
        dispatch(createNewList(payload));
    };
    return createRequesterMediator({ signalHandler : handleSignal })(createListSignal);
};

export const mediateDeleteTaskListRequester = (deleteListSignal, dispatch) => {
    const handleSignal = (payload) => {
        dispatch(deleteAList(payload))
    };
    return createRequesterMediator({ signalHandler : handleSignal })(deleteListSignal);
};

export const mediateSelectTaskListRequester = (selectListSignal, dispatch) => {
    const handleSignal = (payload) => {
        dispatch(selectList(payload));
    };
    return createRequesterMediator({ signalHandler : handleSignal })(selectListSignal);
};

export const mediateTaskListsRequester = (getTaskListSignal, dispatch) => {
    const handleSignal = (payload) => {
        dispatch(getTaskLists(payload));
    };
    return createRequesterMediator({ signalHandler : handleSignal })(getTaskListSignal);
};

const updateListFields = (fields: ListUpdate) => {
    return async (dispatch, getState) => {
        const { login, selectedList } = getState();
        if (!selectedList || !selectedList.id) {
            console.error('[updateListFields] no list selected');
            return;
        }
        try {
            await updateList(login.user.id, selectedList.id, fields);
            // Re-read after await — guard against list switch during the API call
            const currentList = getState().selectedList;
            if (!currentList || currentList.id !== selectedList.id) return;
            dispatch({
                type: EVENT_KEYS.UPDATE_LIST_LIMITS,
                payload: { ...currentList, ...fields },
            });
        } catch (err) {
            console.error('[updateListFields] failed to save list fields:', err);
        }
    };
};

export const mediateUpdateListLimitsRequester = (updateLimitsSignal, dispatch) => {
    const handleSignal = (payload: ListUpdate) => {
        dispatch(updateListFields(payload));
    };
    return createRequesterMediator({ signalHandler : handleSignal })(updateLimitsSignal);
};
